import React, {useEffect, useState} from "react"
import NotificationModal from "../../../../components/common/modals/notification-modal/NotificationModal";
import PointsList from "./PointsList";
import StreakList from "./StreakList";
import BorderWrapper from "../../../../components/dashboard/border-wrapper/BorderWrapper";
import {FireIcon, PointIcon} from "../../../../../assets/icons/defaultIcons";
import {UserAuthService} from "../../../../services/user-auth-api.service";
import PointsButtonSkeleton from "../../../skeletons/home/points/PointsButtonSkeleton";
import {useUser} from "../../../../providers/UserContext";


export default function PointButtons() {
    const [loader ,setLoader] = useState(true);
    const [streakModal ,setStreakModal] = useState(false);
    const [pointModal ,setPointModal] = useState(false);
    const [profileData, setProfileData ] = useState(false)
    const {pointUpdate , setPointUpdate,setChartUpdate , chartUpdate} = useUser();

    async function GetProfileData(isClicked) {
        setLoader(true)
        const response = await UserAuthService.getProfileData();

        if(response?.data?.data?.status){
            setProfileData(response.data?.data?.data?.user)
            setLoader(false)
            setChartUpdate(!chartUpdate)
        }
    }

    useEffect(()=>{
        GetProfileData()
    },[pointUpdate])

    if (loader){
        return <PointsButtonSkeleton/>
    }

    return(
        <div className={'points mt-4 mt-xl-0'}>
            <BorderWrapper key={1}>
                <div className={'points-earn'} onClick={()=>{setPointModal(true)}}>
                    <PointIcon/> {profileData?.points} points
                </div>
            </BorderWrapper>
            <BorderWrapper key={2}>
                <div className={'streak'} onClick={()=>{setStreakModal(true)}}>
                    <FireIcon/> {profileData?.minPointsStreak < 0 ? 0 : profileData?.minPointsStreak} Days
                </div>
            </BorderWrapper>

            <NotificationModal
                show={pointModal}
                close={setPointModal}
                content={<PointsList close={setPointModal}/>}
            />
            <NotificationModal
                show={streakModal}
                close={setStreakModal}
                content={<StreakList close={setStreakModal}/>}
            />
        </div>
    )
}